module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.7f42d848.otf";